/* src/app/activity/activity-form/activity-form.component.scss */
ion-input {
  background: rgba(0, 0, 0, 0.2);
  margin: 5px;
  border-radius: 5px;
}
.garminCircles {
  margin: 1vw;
}
/*# sourceMappingURL=activity-form.component.css.map */
